import { render, staticRenderFns } from "./CertificateBlankStatusSave.vue?vue&type=template&id=39bb35fc&scoped=true&"
import script from "./CertificateBlankStatusSave.vue?vue&type=script&lang=js&"
export * from "./CertificateBlankStatusSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bb35fc",
  null
  
)

export default component.exports